import styled from 'styled-components';

const ScrollableTabsStyled = styled.div`
  overflow: auto hidden;
  width: 100%;
  display: flex;
  scroll-snap-type: x proximity;
  position: relative;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .ScrollableTabs {
    &__item {
      scroll-snap-align: center;
      cursor: pointer;

      &--active {
        border-bottom: 1px solid #000000;
      }
    }
  }
`;

export { ScrollableTabsStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
